import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { FOOD_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { CLEAR_FOODS, FLAG_GETTING_FOODS, GET_FOODS } from '../types/food/Food';

const flagGettingFood = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_FOODS,
    payload: flag,
  });

const getFoods = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingFood(true));
    const query = tableFilters;
    const url = `${FOOD_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const foods = await response.json();
    dispatch({
      type: GET_FOODS,
      payload: foods,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingFood(false));
  }
};

const clearFoods = () => (dispatch) =>
  dispatch({
    type: CLEAR_FOODS,
  });

export { flagGettingFood, getFoods, clearFoods };
